/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface IAppState {
  isMobile: boolean;
  isTablet: boolean;
  isChatRendered: boolean;
}

const initialState = {
  isMobile: false,
  isTablet: false,
  isChatRendered: false,
} as IAppState;

const appStateSlice = createSlice({
  name: 'appState',
  initialState,
  reducers: {
    setMobile(state, action: PayloadAction<boolean>) {
      state.isMobile = action.payload;
    },
    setTablet(state, action: PayloadAction<boolean>) {
      state.isTablet = action.payload;
    },
    setChatRendered(state, action: PayloadAction<boolean>) {
      state.isChatRendered = action.payload;
    },
  },
});

export const { setMobile, setTablet, setChatRendered } = appStateSlice.actions;

export default appStateSlice.reducer;
